export default __webpack_public_path__ + "static/media/company.27063a4c.webp";